import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

type Props = {
  href: string;
  children: React.ReactNode;
  className?: string;
};

function CustomLink({ href, children, className }: Props) {
  const { pathname } = useRouter();
  const isActive = href === pathname;

  return (
    <Link
      href={href}
      className={`${
        isActive ? 'text-[#079992] border-b-2 border-[#079992]' : 'text-[#666666] relative border-b-2 border-transparent after:-bottom-0 after:absolute after:left-0 after:right-0 after:scale-0 after:origin-center after:hover:scale-100 after:h-[2px] after:bg-zinc-900 after:transition after:duration-200'
      } font-semibold py-[8px] ${className}`}
    >
      {children}
    </Link>
  );
}

export default CustomLink;
